import { Container, Eyebrow, Section } from '@vcn/ui'
import { useContent } from '../content'

export function Audiences() {
  const { audiences } = useContent()

  return (
    <Section id="zielgruppen" className="scroll-mt-20 pt-8 sm:pt-10">
      <Container>
        <Eyebrow className="text-center">{audiences.eyebrow}</Eyebrow>

        <div className="mx-auto mt-12 grid max-w-3xl gap-12 md:grid-cols-2 md:gap-10">
          {audiences.items.map((item, index) => (
            <article
              key={item.id}
              id={item.id}
              className={`text-center ${index === 0 ? 'md:text-right' : 'md:text-left'}`}
            >
              <Eyebrow as="h2">{item.role}</Eyebrow>

              <p className="mt-4 text-2xl leading-tight font-bold text-balance text-white sm:text-[1.7rem]">
                {item.title.map((line) => (
                  <span key={line} className="block">
                    {line}
                  </span>
                ))}
              </p>

              <p className="mt-5 text-[0.95rem] leading-relaxed text-pretty text-white/85">
                {item.body}
              </p>
            </article>
          ))}
        </div>
      </Container>
    </Section>
  )
}
